<template>
  <div id="person">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
    ></Topbar>
    <v-container class="main left">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm6 md3 class="logo">
          <img :src="person.avatar ? person.avatar : '/img/avatar.svg'" />
        </v-flex>
        <v-flex xs12 sm6 md9 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name"
                >{{ $t("basic_info") }}
                <div class="edit" @click="editPerson()">
                  {{ "edit" | i18n }}
                </div></v-flex
              >
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.name") }}:</div>
                <div class="value">{{ person.name | checkParam }}</div>
                <div class="label">{{ $t("params.surname") }}:</div>
                <div class="value">{{ person.surname | checkParam }}</div>
                <div class="label">
                  <Phone :phone="$t('params.phone') + ':'"></Phone>
                </div>
                <div class="value">{{ person.phone | checkParam }}</div>
                <div class="label">
                  <Email :email="$t('params.email') + ':'"></Email>
                </div>
                <div class="value">{{ person.email | checkParam }}</div>
                <div class="label">{{ $t("params.dni") }}:</div>
                <div class="value">{{ person.dni | checkParam }}</div>
                <div class="label">{{ $t("params.birthday") }}:</div>
                <div class="value">
                  {{ person.birthday | checkParam | showDate }}
                </div>
                <div class="label">{{ $t("params.gender") }}:</div>
                <div class="value">{{ person.gender | checkParam | i18n }}</div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.address") }}:</div>
                <div class="value">{{ person.address | checkParam }}</div>
                <div class="label">{{ $t("params.city") }}:</div>
                <div class="value">{{ person.city | checkParam }}</div>
                <div class="label">{{ $t("params.cp") }}:</div>
                <div class="value">{{ person.cp | checkParam }}</div>
                <div class="label">{{ $t("params.state") }}:</div>
                <div class="value">{{ person.state | checkParam }}</div>
                <div class="label">{{ $t("params.country") }}:</div>
                <div class="value">
                  <Country
                    v-if="person.country_id != null"
                    :country="getCountry(person.country_id)"
                  ></Country>
                  <div v-else class="value">{{ "" | checkParam }}</div>
                </div>
                <div class="label">{{ $t("params.nacionality") }}:</div>
                <div class="value">
                  <Country
                    v-if="person.nacionality != null"
                    :country="getCountry(person.nacionality)"
                  ></Country>
                  <div v-else class="value">{{ "" | checkParam }}</div>
                </div>
                <div class="label" v-if="person.b_alergy">
                  {{ $t("params.alergy") }}:
                </div>
                <div v-if="person.b_alergy" class="value">
                  {{ person.alergy_text | checkParam }}
                </div>
                <div class="label" v-if="person.b_alergy">
                  {{ $t("params.other_allergies") }}:
                </div>
                <div v-if="person.b_alergy" class="value">
                  {{ person.other_allergies | checkParam }}
                </div>
                <div class="label" v-if="!person.b_alergy">
                  {{ $t("params.alergies") }}:
                </div>
                <div v-if="!person.b_alergy" class="value">
                  {{ "false" | checkParam }}
                </div>
                <div class="label">{{ $t("params.diet") }}:</div>
                <div class="value" v-if="person.diet != null">
                  {{ $store.state.diet[person.diet].name | checkParam | i18n }}
                </div>
                <div class="value" v-else>No</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex
          xs12
          sm12
          md12
          class="info role"
          v-for="(role, key) in person.current_roles"
          :key="key"
        >
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name" @click="role.visible = !role.visible"
                >{{ $t("current_role") }}
                {{
                  $store.getters["persons/getContactTypeById"](
                    role.contact_type_id
                  ).name | i18n
                }}
              </v-flex>
              <!-- JUGADOR -->
              <v-flex
                v-show="role.visible"
                xs12
                v-if="
                  role.contact_type_id == 'NlpqcExrTFJlZ1NSakl5UXQxVTBkZz09'
                "
                class="player"
              >
                <v-container>
                  <v-layout row wrap class="section">
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.position") }}:</div>
                      <div class="value">
                        {{ getPosition(role.position) | checkParam | i18n }}
                      </div>
                      <div class="label">{{ $t("params.number") }}:</div>
                      <div class="value">{{ role.number | checkParam }}</div>
                      <div class="label">{{ $t("params.club") }}:</div>
                      <div class="value">
                        <router-link
                          class="club"
                          :to="$root.entityUrl('club', role.team.club.id)"
                          >{{ role.team.club.name | checkParam }}</router-link
                        >
                      </div>
                      <div class="label">{{ $t("team") }}:</div>
                      <div class="value">
                        <router-link
                          class="team"
                          :to="$root.entityUrl('team', role.team.id)"
                          >{{ role.team.name | checkParam }}</router-link
                        >
                      </div>
                      <div class="label">{{ $t("event") }}:</div>
                      <div class="value">
                        {{
                          $root.formatEventName(
                            role.event.name,
                            role.event.edition
                          ) | checkParam
                        }}
                      </div>
                      <div class="label">{{ $t("params.category") }}:</div>
                      <div class="value">
                        {{ role.team.category.name | checkParam }} -
                        {{ role.team.category.max_age | checkParam }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">
                        {{ $t("params.authoritzation") }}:
                      </div>
                      <div class="value">
                        {{ role.authoritzation | checkParam }}
                      </div>
                      <div class="label">{{ $t("params.altura") }}:</div>
                      <div class="value">{{ role.altura | checkParam }}</div>
                      <div class="label" v-if="role.b_medicamento">
                        {{ $t("params.medicamento") }}:
                      </div>
                      <div v-if="role.b_medicamento" class="value">
                        {{ role.medicamento | checkParam }}
                      </div>
                      <div class="label" v-if="!role.b_medicamento">
                        {{ $t("params.medicamento") }}:
                      </div>
                      <div v-if="!role.b_medicamento" class="value">
                        {{ "false" | checkParam }}
                      </div>
                      <div class="label">{{ $t("params.swim") }}:</div>
                      <div class="value">{{ role.swim | checkParam }}</div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

              <!-- STAFF -->
              <v-flex
                v-show="role.visible"
                xs12
                v-else-if="
                  [
                    'L2F4ckN4SHh3UWc2U1d3TkVaU0dBUT09',
                    'Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09'
                  ].includes(role.contact_type_id)
                "
                class="player"
              >
                <v-container>
                  <v-layout row wrap class="section">
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.cargo") }}:</div>
                      <div class="value">
                        {{
                          $store.getters["persons/getContactTypeById"](
                            role.contact_type_id
                          ).name
                            | i18n
                            | checkParam
                        }}
                      </div>
                      <div class="label">{{ $t("params.level") }}:</div>
                      <div class="value">
                        {{
                          ("staff_level." +
                            $store.getters.getStaffLevel(role.nivel).name)
                            | i18n
                            | checkParam
                        }}
                      </div>
                      <div class="label">
                        {{ $t("params.authoritzation") }}:
                      </div>
                      <div class="value">
                        {{ role.authoritzation | checkParam }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.club") }}:</div>
                      <div class="value">
                        <router-link
                          class="club"
                          :to="$root.entityUrl('club', role.team.club.id)"
                          >{{ role.team.club.name | checkParam }}</router-link
                        >
                      </div>
                      <div class="label">{{ $t("params.team") }}:</div>
                      <div class="value">
                        <router-link
                          class="team"
                          :to="$root.entityUrl('team', role.team.id)"
                          >{{ role.team.name | checkParam }}</router-link
                        >
                      </div>
                      <div class="label">{{ $t("params.event") }}:</div>
                      <div class="value">
                        {{
                          $root.formatEventName(
                            role.event.name,
                            role.event.edition
                          ) | checkParam
                        }}
                      </div>
                      <div class="label">{{ $t("params.category") }}:</div>
                      <div class="value">
                        {{ role.team.category.name | checkParam }} -
                        {{ role.team.category.max_age | checkParam }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <!-- RESPONSABLE -->
              <v-flex
                v-show="role.visible"
                xs12
                v-else-if="['VGpRVTdzRzI1SzhOM1RPdjZEZ3g1Zz09']"
                class="player"
              >
                <v-container>
                  <v-layout row wrap class="section">
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.cargo") }}:</div>
                      <div class="value">
                        {{
                          $store.getters["persons/getContactTypeById"](
                            role.contact_type_id
                          ).name
                            | i18n
                            | checkParam
                        }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">
                        {{ $t("params.authoritzation") }}:
                      </div>
                      <div class="value">
                        {{ role.authoritzation | checkParam }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.son") }}:</div>
                      <div class="value">
                        <router-link
                          class="club"
                          :to="
                            $root.entityUrl(
                              event.is_campus ? 'participant' : 'person',
                              role.player_id
                            )
                          "
                          >{{ role.player_name | checkParam }}</router-link
                        >
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("event") }}:</div>
                      <div class="value">
                        {{
                          $root.formatEventName(
                            role.event.name,
                            role.event.edition
                          ) | checkParam
                        }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
              <!-- OTHERS -->
              <v-flex v-show="role.visible" xs12 v-else class="player">
                <v-container>
                  <v-layout row wrap class="section">
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("params.cargo") }}:</div>
                      <div class="value">
                        {{
                          $store.getters["persons/getContactTypeById"](
                            role.contact_type_id
                          ).name
                            | i18n
                            | checkParam
                        }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">
                        {{ $t("params.authoritzation") }}:
                      </div>
                      <div class="value">
                        {{ role.authoritzation | checkParam }}
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <div class="label">{{ $t("event") }}:</div>
                      <div class="value">
                        {{
                          $root.formatEventName(
                            role.event.name,
                            role.event.edition
                          ) | checkParam
                        }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
          <!-- <LastUpdate :data="person.user_modify"></LastUpdate> -->
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <LastUpdate :data="person.user_modify"></LastUpdate>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="notes">
        <NoteList
          :notes="person.notes"
          :page="'person'"
          :id="id"
          @create_note="createNote"
        ></NoteList>
      </v-layout>
    </v-container>
    <ContactRelationsList
      :contacts_rel="person.current_roles"
      class="contact right"
    ></ContactRelationsList>
  </div>
</template>

<script>
import i18n from "@/i18n";
import NoteList from "@/components/ui/NoteList";
import TeamCard from "@/components/ui/cards/mini/Team";
import Topbar from "@/components/ui/Topbar";

import ContactRelationsList from "@/components/ui/ContactRelationsList";

import Phone from "@/components/ui/labels/Phone";
import Email from "@/components/ui/labels/Email";
import Country from "@/components/ui/labels/Country";
import LastUpdate from "@/components/ui/LastUpdate";

export default {
  name: "CardPerson",
  components: {
    NoteList,
    TeamCard,
    Topbar,
    Phone,
    Email,
    Country,
    ContactRelationsList,
    LastUpdate
  },
  props: {},
  data() {
    return {
      id: this.$route.params.id,
      current_roles: []
    };
  },
  computed: {
    person() {
      var oPerson = {
        ...this.$store.getters["persons/get_by_id"](this.$route.params.id)
      };
      if (!oPerson) oPerson = {};

      oPerson.gender =
        oPerson.gender != null ? "gender." + oPerson.gender : null;

      // var aEvents = [];
      // if( typeof oClub.teams !== 'undefined' ){
      //     for( var key in oClub.teams ){
      //         var team = oClub.teams[ key ];
      //         if( typeof aEvents[ team.event.id ] === 'undefined' ){
      //             team.event.name = this.formatEventName( team.event.name, team.event.edition );
      //             aEvents[ team.event.id ] = team.event;
      //             aEvents[ team.event.id ].teams = [];
      //         }
      //         aEvents[ team.event.id ].teams.push( {
      //             name: ( team.name == null )? oClub.name : team.name,
      //             category: team.category,
      //             status: team.status
      //         });
      //     }
      // }
      // oClub.events = ObjectToArray( aEvents );

      var aAlergies = this.$store.getters["persons/getAlergies"]();
      // if( oPerson.alergy != null ){
      //     var alergies = oPerson.alergy.split(',')
      //     var sAlergies = ""
      //     alergies.forEach( alergy => {
      //         if( sAlergies != "" ) sAlergies+= ", "
      //         sAlergies+= aAlergies[ alergy ].name
      //     })

      //     oPerson.alergy = sAlergies
      // }

      oPerson.notes = ObjectToArray(oPerson.notes);
      oPerson.notes.sort(function(n1, n2) {
        if (moment(n1.last_update).valueOf() < moment(n2.last_update).valueOf())
          return 1;
        return -1;
      });

      if (typeof oPerson.current_roles === "undefined")
        oPerson.current_roles = [];
      else {
        oPerson.current_roles.forEach(role => {
          role.visible = true;
        });
      }

      if (this.$store.getters.isEventSelected) {
        var event = this.$store.getters["events/getCurrentEvent"]();
        this.current_roles = oPerson.current_roles.filter(role => {
          return role.event.id == event.id;
        });
        oPerson.current_roles = this.current_roles;
      } else {
        this.current_roles = oPerson.current_roles;
      }

      oPerson.alergy_text = "";
      if (oPerson.b_alergy) {
        var alergies = this.$store.state.persons.alergies;
        if (typeof oPerson.alergy === "object")
          oPerson.alergy = oPerson.alergy.toString();
        if (typeof oPerson.alergy !== "undefined" && oPerson.alergy != null) {
          oPerson.alergy.split(",").forEach(alergy => {
            oPerson.alergy_text += oPerson.alergy_text != "" ? "," : "";
            oPerson.alergy_text += i18n.t(alergies[alergy].name);
          });
        }
      }
      // this.person = oPerson

      return oPerson;
    },

    event() {
      return this.$store.getters["events/getCurrentEvent"]();
    }

    //   contacts_rel() {
    //       if( typeof this.person.current_roles === 'undefined' ) return [];
    //       console.log( this.person.current_roles );
    //       return [...this.person.current_roles];

    //   }

    //   contacts() {
    //       return [ { name: 'Manolito García', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' }, { name: 'Mario Martinez', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' } ];
    //   }
  },
  created() {
    this.$overlay.loading();

    this.loadDataPage();
  },
  methods: {
    loadDataPage() {
      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      var id = this.$route.params.id;
      var self = this;
      this.$store.dispatch("persons/load_by_id", { id: id }).then(function() {
        self.$overlay.hide();
      });
    },
    createNote() {
      this.$card.note({
        current_page: "person",
        current_id: this.$route.params.id
      });
    },

    createContactRelationship() {
      this.$card.contactrel({
        current_page: "person",
        current_id: this.$route.params.id
      });
    },

    getCountry(id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) };
      }
      return false;
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "remove":
          this.fnRemove(emit.params);
          break;
        case "create_note":
          this.createNote(emit.params);
          break;
        case "create_relationship":
          this.createContactRelationship(emit.params);
          break;
        case "rel_club_event":
          this.fnRelClubEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
      }
    },

    fnRemove() {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("persons.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
          self.$store.dispatch("persons/remove", self.id).then(function() {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var page = event ? "event_" : "";
            page = page + "persons_home";
            self.$router.push({
              name: page,
              params: {
                event: self.$root
                  .formatEventUrl(event.name, event.edition)
                  .replace("/event/", "")
              }
            });
          });
        }
      );
    },

    getPosition(position) {
      var pos = this.$store.getters["persons/getPosition"](position);
      if (pos && typeof pos.name !== "undefined") {
        return pos.name;
      }

      return null;
    },

    editPerson() {
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event
        ? this.$root
            .formatEventUrl(event.name, event.edition)
            .replace("/event/", "")
        : null;

      this.$router.push({
        name: "persons_edit",
        params: { event: event, id: this.person.id }
      });
    },

    editRole(key) {
      var event = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]()
        : false;
      event = event
        ? this.$root
            .formatEventUrl(event.name, event.edition)
            .replace("/event/", "")
        : null;
      var page = event ? "event_" : "";
      page = page + "persons_role_edit";
      var role = this.person.current_roles[key];

      var type = "";
      switch (parseInt(role.contact_type_id)) {
        case 107:
          type = "player";
          break;
        case 5:
        case 108:
        case 6:
          type = "manager";
          break;
        case 1:
        case 2:
          type = "staff";

        case 111:
          type = "team";
          break;
      }

      this.$router.push({
        name: page,
        params: {
          event: event,
          id: this.person.id,
          role_id: role.id,
          type: type
        }
      });
    },

    fnDestroy() {
      this.$destroy();
    }
  },
  filters: {},
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  }
};
</script>

<style lang="scss" scoped>
#person {
  width: 100%;
  display: inline-block;

  .container {
    width: calc(100% - 350px);
    padding: 0px;
    max-width: 100%;

    &.main {
      overflow-y: auto;
      height: calc(100vh - 110px);
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }
    }
  }

  .contact {
    width: 20%;
    width: 350px;
    padding: 20px;
  }

  .logo {
    width: 150px;
    height: 150px;
    border-radius: 50%;

    img {
      object-fit: contain;
      object-position: center;
      height: 100%;
      width: auto;
      margin: 0 auto;
      display: block;
      margin-top: 50px;
      opacity: 0.5;
    }
  }
  .info {
    .container {
      margin: 0;
      padding: 0 20px;
      padding-left: 40px;
      width: 100%;

      .section {
        margin-bottom: 25px;

        .name {
          font-weight: lighter;
          font-size: 24px;
          @include font-size(14px);
          border-bottom: 1px solid #ddd;
          margin: 10px 0 20px 0;
          color: $main-color;
          text-transform: uppercase;
          margin-bottom: 20px;
          border-bottom: 2px solid $complem-color-dark;
          color: $complem-color-dark;
          position: relative;
        }

        .label {
          font-family: $text-light;
          @include font-size(14px);
          width: 40%;
          float: left;
          line-height: 20px;
        }

        .value {
          font-family: $text;
          font-weight: lighter;
          @include font-size(14px);
          width: 60%;
          float: left;
          margin-bottom: 10px;
        }

        .edit {
          background-image: url(/img/edit-b.svg);
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: left center;
          position: absolute;
          right: 0;
          top: -5px;
          padding-left: 20px;
          text-transform: none;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }

    &.role .name {
      position: relative;
      width: fit-content;
      cursor: pointer;

      &::after {
        content: "";
        width: 30px;
        height: 15px;
        background: url(/img/down.svg);
        background-repeat: no-repeat;
        background-size: 15px;
        background-position: center right;
        position: absolute;
      }
    }
  }
}
</style>
